(function(){
var TSID='X3A4B818203BD494F9827D86A9543F0D1',KEY='pk-ts-v1',daten=null;
function fuellen(){
if(!daten)return;
var note=daten.note.toFixed(2).replace('.',',');
document.querySelectorAll('[data-pk-ts]:not([data-pk-ts-ok])').forEach(function(el){
el.querySelectorAll('[data-pk-ts-note]').forEach(function(x){x.textContent=note;});
el.querySelectorAll('[data-pk-ts-anzahl]').forEach(function(x){x.textContent=daten.anzahl.toLocaleString('de-DE');});
el.querySelectorAll('[data-pk-ts-stern]').forEach(function(x){x.hidden=false;});
el.querySelectorAll('.pk-ts__sterne').forEach(function(x){x.style.setProperty('--w',(daten.note/5*100).toFixed(1)+'%');});
el.hidden=false;el.setAttribute('data-pk-ts-ok','');
});
}
function laden(){
try{var c=JSON.parse(sessionStorage.getItem(KEY)||'null');if(c&&c.t>Date.now()-21600000){daten=c;fuellen();return;}}catch(e){}
fetch('https://api.trustedshops.com/rest/public/v2/shops/'+TSID+'/quality/reviews.json').then(function(r){return r.json();}).then(function(j){
var q=j&&j.response&&j.response.data&&j.response.data.shop.qualityIndicators.reviewIndicator;
if(!q||!q.overallMark)return;
daten={note:q.overallMark,anzahl:q.activeReviewCount,t:Date.now()};
try{sessionStorage.setItem(KEY,JSON.stringify(daten));}catch(e){}
fuellen();
}).catch(function(){});
}
new MutationObserver(function(){if(daten)fuellen();}).observe(document.documentElement,{childList:true,subtree:true});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',laden);else laden();

/* Warenkorb-Seite: Versandhinweis wie im Warenkorb-Overlay (ab 30 € versandkostenfrei) */
var GRENZE=3000,wkLauft=false;
function wkSeite(){
var n=document.querySelector('.cart .tax-note:not(:has(.pk-wk-versand))');
if(!n||wkLauft)return;wkLauft=true;
fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
n.innerHTML='<p class="pk-wk-versand">inkl. MwSt.<br>'+(c.total_price>=GRENZE?'Kostenloser Versand in Deutschland':'zzgl. <a href="/policies/shipping-policy">4,95 € Versand</a> in Deutschland')+'</p>';
}).catch(function(){}).then(function(){wkLauft=false;});
}
new MutationObserver(wkSeite).observe(document.documentElement,{childList:true,subtree:true});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wkSeite);else wkSeite();
})();
